import React, { useLayoutEffect, Fragment } from "react"
import { useSelector } from "react-redux"

import { haveAuth, isInPosDevice } from "utils"
import CheckoutCashTypesHeader from "./CheckoutCashTypesHeader"
import CheckoutCashTypesCard from "./CheckoutCashTypesCard"
import classes from "./index.module.scss"

const CheckoutCashTypes = props => {
  const {
    total,
    cashTypes,
    setCashTypes,
    isLinkPay,
    setIsLinkPay,
    setFocusedCashType,
    paymentScrollRef,
    multiplePayment,
    setMultiplePayment
  } = props

  const systemCashTypes =
    useSelector(state => state.systemSettings.cashTypes)

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const posTerminals =
    useSelector(state => state.posTerminals[accountId] || [])

  const getAllCashTypes = () => {
    const results =
      systemCashTypes.map(systemCashType => ({
        name: systemCashType,
        value: systemCashType,
        terminalName: "",
        isTerminal: false
      }))

    if (isInPosDevice()) {
      results.push({
        name: "کارتخوان",
        value: window.posName === "bpMellat" ? "کارتخوان به پرداخت" : "کارتخوان سداد",
        terminalName: "",
        isTerminal: true
      })
    }

    if (!isInPosDevice()) {
      posTerminals.forEach((myPosTerminal) => {
        results.push({
          name: myPosTerminal.name,
          value: myPosTerminal.value,
          terminalName: myPosTerminal.terminalName,
          type: myPosTerminal.type,
          ipAddress: myPosTerminal.ipAddress,
          isTerminal: true
        })
      })

      results.push({
        name: "واتساپ",
        value: "واتساپ",
        terminalName: "",
        isTerminal: false
      })
    }

    if (haveAuth(["smsPaymentLink"])) {
      results.push({
        name: "SMS",
        value: "SMS",
        terminalName: "",
        isTerminal: false
      })
    }

    return results
  }

  const initialCashtype = () => {
    isInPosDevice()
      ?
      setCashTypes([{
        amount: total,
        name: "کارتخوان",
        value: window.posName === "bpMellat" ? "کارتخوان به پرداخت" : "کارتخوان سداد",
        isTerminal: true
      }])
      :
      setCashTypes([{
        amount: total,
        name: "نقدی",
        value: "نقدی",
        isTerminal: false
      }])
  }

  useLayoutEffect(() => {
    initialCashtype()
  }, [])

  const allCashTypes = getAllCashTypes()

  return (
    <Fragment>
      <CheckoutCashTypesHeader
        total={total}
        isLinkPay={isLinkPay}
        cashTypes={cashTypes}
        setCashTypes={setCashTypes}
        multiplePayment={multiplePayment}
        setMultiplePayment={setMultiplePayment}
        setFocusedCashType={setFocusedCashType}
      />

      <div className={classes["cash-types"]}>
        {allCashTypes.map((cashType, cIndex) => (
          <CheckoutCashTypesCard
            key={cIndex}
            total={total}
            cashType={cashType}
            setIsLinkPay={setIsLinkPay}
            setMultiplePayment={setMultiplePayment}
            paymentScrollRef={paymentScrollRef}
            active={cashTypes.some(c => c.value === cashType.value)}
            multiplePayment={multiplePayment}
            setCashTypes={setCashTypes}
          />
        ))}
      </div>
    </Fragment>
  )
}

export default React.memo(CheckoutCashTypes)